import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  OnChanges,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import '@esi/leaf-icons';

@Component({
  selector: 'cigna-leaf-icon',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span #templateSpot></span>`,
  // ideally would just use template binding, but web component seems to init before attributes kick in :(
  // so that is reason for the renderElement technique
  // template: `<leaf-icon
  //     [attr.width]="width"
  //     [attr.height]="height"
  //     [attr.svg]="svgIcon"
  //     [attr.rotate]="rotate"
  //     [attr.pulse]="pulse"
  //     [attr.spin]="spin"
  //     [attr.flip]="flip"
  //   ></leaf-icon
  // >`,
})
export class CignaLeafIconComponent implements OnChanges {
  @Input({ required: true }) svgIcon: string;

  @Input() ariaLabel?: string;
  @Input() ariaHidden?: boolean;

  @Input() height?: number;
  @Input() width?: number;

  @Input() rotate?: number;
  @Input() pulse?: boolean;
  @Input() spin?: boolean;
  @Input() flip?: 'vertical' | 'horizontal' | 'both';

  @ViewChild('templateSpot', { read: ElementRef, static: true })
  templateSpot: ElementRef;

  ngOnChanges() {
    this.renderElement();
  }

  renderElement() {
    const iconElement = document.createElement('leaf-icon');

    iconElement.setAttribute('svg', this.svgIcon);

    if (this.ariaLabel) {
      iconElement.setAttribute('aria-label', this.ariaLabel);
    }

    if (this.ariaHidden) {
      iconElement.setAttribute('aria-hidden', this.ariaHidden.toString());
    }

    if (this.height) {
      iconElement.setAttribute('height', this.height.toString());
    }

    if (this.width) {
      iconElement.setAttribute('width', this.width.toString());
    }

    if (this.spin) {
      iconElement.setAttribute('spin', 'true');
    }

    if (this.flip) {
      iconElement.setAttribute('flip', this.flip);
    }

    if (this.pulse) {
      iconElement.setAttribute('pulse', 'true');
    }

    if (this.rotate) {
      iconElement.setAttribute('rotate', this.rotate.toString());
    }

    while (this.templateSpot.nativeElement.firstChild) {
      this.templateSpot.nativeElement.removeChild(
        this.templateSpot.nativeElement.firstChild,
      );
    }
    this.templateSpot.nativeElement.append(iconElement);
  }
}
